import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allStudents,
    addSpeedCheck,
 } from 'Actions';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = { 
            
            seldate:'', 
            student:this.props.data.student, 
        };
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }   

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    addHandleSubmit(event){
        event.preventDefault();
        
        this.props.addSpeedCheck(event).then((data) => {   
        
            if(data.status==1){                    
                this.setState({ 
                    student:'',
                    seldate:'',
                    club:'',
                 });

                document.getElementById("addform").reset();  
                setTimeout(() => {
                    this.props.onClick();
                }, 2000);                  
            }
        });
        
    }  

    handleNumberic(e) {               
        if (!/[0-9,.]/.test(e.key)) {
            e.preventDefault();
        } 
    }


render() {

    const { studentlists, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
            label: stdval.student,  
            value: stdval.uudID
        }
    });

    
      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8">
                            <RctCollapsibleCard heading="Create Speed Check">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-md-12"> 
                                            <div className="col-sm-12 col-md-6">
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                </FormGroup>
                                            </div>    
                                        </div> 
                                        <div className="col-sm-12 col-md-12">
                                            <div className="col-sm-12 col-md-6">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>     
                                            </div>                                     
                                        </div> 

                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <div className="table-responsive">
                                                <Table>
                                                    <TableHead>
                                                        <TableRow hover>                                                           
                                                            <TableCell align="center">SHOT</TableCell>
                                                            <TableCell align="center">CLUB SPEED</TableCell>
                                                            <TableCell align="center">BALL SPEED </TableCell>
                                                            <TableCell align="center">CARRY</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(() => {
                                                            let td = [];
                                                            
                                                            for (let i = 1; i <=5; i++) {
                                                                td.push(<TableRow key={i}>
                                                                        <TableCell>{i}</TableCell>
                                                                        <TableCell><input type="text" name={'clubspeed_'+i} id={'clubspeed_'+i} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)}/></TableCell>
                                                                        <TableCell><input type="text" name={'ballspeed_'+i} id={'ballspeed_'+i} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} /></TableCell>
                                                                        <TableCell><input type="text" name={'carry_'+i} id={'carry_'+i} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} /></TableCell>
                                                                    </TableRow>); 
                                                            }
                                                            return td;
                                                        })()} 
                                                    </TableBody>
                                                </Table>   
                                            </div>  
                                            </div>       
                                        </div>

                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />  
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { studentlists, loading } = mostlyused;
    return { studentlists, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    addSpeedCheck,
})(AddItems);
